	import AddUser from "@/components/admin/AddUser" 
<template>

	<Tile title="Add Organisation" :buttons="button" @addOrganisation="addOrganisation" @reset="reset" @viewProfile="viewProfile">
		<template v-slot:content>
			<div v-if="!loading" :class="{'d-none': id}">
				<form ref="form">
					<OrganisationForm :organisation="{}" v-on:change="(u) => organisation = u"></OrganisationForm>
				</form>
			</div>
			<div v-if="loading">
				<v-progress-linear class="mt-5" indeterminate></v-progress-linear>
			</div>
			<div :class="{'d-none': !id}">
				<div>
					{{message}}
				</div>
			</div>
		</template>
	</Tile>
</template>
<script type="text/javascript">
	import Tile from "@/components/elements/Tile";
	import OrganisationForm from "@/components/admin/forms/OrganisationForm"
	export default {
		name: "AddOrganisation", 
		data: () => {
			return {
				id: false,
				organisation: {},
				loading: false,
				error: false 
			}
		},
		computed: {
			message(){
				return `Account created! Look at ${this.organisation.name}'s profile.`;
			},
			button(){
				if( !this.id){
					return [
						{emit: 'reset', icon: 'mdi-close'}, {emit: 'addOrganisation', color: 'green'}];
				}	
				return [
						{emit: 'reset', icon: 'mdi-plus'}, 
						{emit: 'viewProfile',  color: "primary"}, 
					]
			}

		},
		methods: {
			addOrganisation(){
				var self = this;
				self.loading = true;
				var organisation = self.$store.getters.getEmptyOrganisation;
				organisation.name = self.organisation.name;
				self.$store.dispatch("newOrganisation", organisation).then(( id ) => {
					self.id = id;
					self.loading = false;
				}).catch(() => {
					this.error = true;
				})
			}, 
			viewProfile(){
				this.$router.push({path: `organisations/${this.id}` })
			},
			reset(){
				this.id = false;
				this.$refs.form.reset();
			}
		},
		components: {
			Tile,
			OrganisationForm
		}
	}
</script>
